<template lang="pug">
.modal.fade(tabindex="-1" data-backdrop="static")
  .modal-dialog
    .modal-content.mini
      form(v-on:submit.prevent="submit")
        .modal-header
          button.close(type="button" @click="close")
            i.fa.fa-times
          h3 {{ locationsStore.newForm ? 'New Location' : 'Search Locations' }}

        .modal-body
          New(
            v-if="locationsStore.newForm"
          )
          Search(
            v-if="!locationsStore.newForm"
            :add-action="addAction"
            :disabled-location-ids="disabledLocationIds"
          )

        .modal-footer
          button.btn.btn-success(
            type="button"
            v-if="locationsStore.newForm"
            @click="createAndAdd"
          )
            i.fa.fa-save
            |
            | Save

          button.btn.btn-default(
            type="button"
            @click="close"
          )
            | Close
</template>

<script>
  import { mapStores } from 'pinia'
  import { useLocationStore } from '@/stores/location'
  import { useLocationsStore } from '@/stores/locations'

  import LoaderOverlay from '@/components/shared/loader_overlay.vue'
  import New from './new.vue'
  import Pagination from '@/components/shared/pagination.vue'
  import Search from './search.vue'

  export default {
    components: {
      LoaderOverlay,
      New,
      Pagination,
      Search
    },

    props: {
      addAction: {
        type: Function,
        required: true
      },

      disabledLocationIds: {
        type: Array,
        default() { return [] }
      },
    },

    computed: {
      ...mapStores(useLocationsStore),
      ...mapStores(useLocationStore),
    },

    watch: {
      'locationsStore.showModal': function (val) {
        if(val) {
          this.fetchLocations()
          jQuery(this.$el).modal('show')
        } else {
          jQuery(this.$el).modal('hide')
          this.reset()
        }
      },
    },

    methods: {
      async fetchLocations() {
        await this.locationsStore.search()
      },

      async showForm() {
        await this.reset()

        this.locationsStore.newForm = true
      },

      async submit() {
        this.locationsStore.newForm ? this.createAndAdd() : this.close()
      },

      async createAndAdd() {
        this.locationStore.create().then(async (resp) => {
          this.addAction({ locationId: resp.data.location.id })
          this.locationsStore.showModal = false
        }).catch(({ response: { data: message }}) => {
          this.$store.dispatch('messages/addError', message)
        })
      },

      async close() {
        this.locationsStore.showModal = false

        this.reset()
      },

      async reset() {
        this.locationsStore.$reset()
      },
    }
  }
</script>
